import { Overlay } from '@/models/ui/overlay';
import Vue, { DirectiveOptions, VNode, VNodeDirective } from 'vue';
import LoadingOverlayComponent from '../components/loading-overlay/loading-overlay.vue';
import { isElementInViewport } from '../utils/ui';
import { spinWhile } from '../utils/utils';

let overlayId = 1

class LoadingDirective implements DirectiveOptions {
    private overlays: Overlay[] = []

    constructor() {
        this.bind = this.bind.bind(this);
        this.update = this.update.bind(this);
        this.unbind = this.unbind.bind(this);
    }

    bind(el: HTMLElement, binding: VNodeDirective, vnode: VNode) {
        const overlay = new Overlay(`overlay_${++overlayId}`, el)
        if (vnode.componentInstance && vnode.componentInstance.$attrs.loadingOptions) {
            Object.assign(overlay.options, vnode.componentInstance.$attrs.loadingOptions);
        }

        this.overlays.push(overlay)
    }

    unbind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
        const overlay = this.findOverlay(el)
        this.overlays.splice(this.overlays.indexOf(overlay), 1)
    }

    update(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode) {
        const overlay = this.findOverlay(el)

        if (binding.oldValue !== binding.value) {
            if (binding.value) {
                this.show(overlay);
            } else {
                overlay.hide();
            }
        }
    }

    private async show(ov: Overlay) {
        const activeOverlay = $(ov.target).find(`#${ov.id}`).get(0);
        if (activeOverlay) {
            ov.show(activeOverlay)
            return;
        }

        try {
            await spinWhile(() => !isElementInViewport(ov.target), { intervalMs: 5, maxIteration: 10 })
        } catch (e) {
            // tslint:disable-next-line: no-console
            console.debug(`Target element is not visible on the screen after ${e.ellapsedTime}ms`, ov.target)
            return
        }

        const position = window.getComputedStyle(ov.target).position;
        const elFrame =  ov.target.getBoundingClientRect() as DOMRect

        if (position === 'static' || position === '') {
            ov.customStyles.push('position')
            ov.target.style.position = 'relative';
        }

        if (elFrame.height < 60) {
            ov.customStyles.push('height')
            ov.target.style.height = `60px`
        }

        const overlayComponent = this.createOverlayComponent(ov)
        ov.target.append(overlayComponent.$el)
        ov.show( overlayComponent.$el as HTMLElement)
    }

    private findOverlay(target: HTMLElement): Overlay {
        return this.overlays.find(p => p.target === target)
    }

    private createOverlayComponent(overlay: Overlay) {
        const OverlayComponent = Vue.extend(LoadingOverlayComponent)
        const componentInstance = new OverlayComponent({
            propsData: {
                overlay
            }
        })
        componentInstance.$mount()

        return componentInstance
    }
}

export default new LoadingDirective()
